import {
  Inject,
  Injectable
} from '@angular/core';
import {
  ID,
  QueryEntity
} from '@datorama/akita';
import {
  ChartsDashboardStore,
  ChartsDashboardState
} from './charts-dashboard.store';
import { Observable } from 'rxjs';
import { ChartsDashboardCardQuery } from 'app/charts-dashboard/state/card';
import {
  filter,
  map
} from 'rxjs/operators';
import { IChartDashboard } from './dashboard.model';
import { ICard } from '../card';
import { ILayoutEntity } from 'app/charts-dashboard/interfaces';
import { AppStore } from '@iv/store/app.store';
import * as Redux from 'redux';
import { AppState } from '@iv/store/app.reducer';
import { getCurrentTab } from '@iv/store/tabs/tabs.selectors';
import {
  ChartsDashboardSeriesQuery,
  IChartSeries
} from '../series';

@Injectable({providedIn: 'root'})
export class ChartsDashboardQuery extends QueryEntity<ChartsDashboardState> {

  constructor(
    protected store: ChartsDashboardStore,
    private cards: ChartsDashboardCardQuery,
    private series: ChartsDashboardSeriesQuery,
    @Inject(AppStore) private redux: Redux.Store<AppState>
  ) {
    super(store);
  }

  public get getCurrentDashboard(): IChartDashboard<ID> {
    return this.getAll().find((dashboard: IChartDashboard<ID>) => dashboard.id === getCurrentTab(this.redux.getState()).data.dashboard.id);
  }

  public get getCurrentDashboardId(): ID {
    return this.getCurrentDashboard.id;
  }

  public selectDashboard(dashboardId: ID): Observable<IChartDashboard<ICard<IChartSeries>>> {
    return this.selectEntity(dashboardId)
      .pipe(
        filter((dashboard: IChartDashboard<ID>) => dashboard !== undefined),
        map((dashboard: IChartDashboard<ID>) => {
          return {
            ...dashboard,
            cards: dashboard.cards.map((cardId: string) => {
              const card: ICard<ID> = this.cards.getAll().find((_card: ICard<ID>) => _card.id === cardId);

              return {
                ...card,
                chartSeries: this.series.getSeriesFromCard(card)
              };
            })
          };
        })
      );
  }

  public selectDashboardCards(): Observable<ICard<IChartSeries>[]> {
    return this.selectDashboard(this.getCurrentDashboardId)
      .pipe(map((dashboard: IChartDashboard<ICard<IChartSeries>>) => dashboard.cards));
  }

  public selectDashboardLayout(): Observable<ILayoutEntity> {
    return this.selectDashboard(this.getCurrentDashboardId)
      .pipe(map((dashboard: IChartDashboard<ICard<IChartSeries>>) => dashboard.layout));
  }

  public getDashboardSnapshot(dashboardId: ID): IChartDashboard<ICard<IChartSeries>> {
    const dashboard: IChartDashboard<ID> = this.getEntity(dashboardId);

    return {
      ...dashboard,
      cards: this.cards.getCardsFromDashboard(dashboard).map((card: ICard<ID>) => {
        return {
          ...card,
          chartSeries: this.series.getSeriesFromCard(card)
        };
      })
    };
  }
}
